import React, { Fragment } from 'react';
import cx from 'classnames';

const errorHelper = (config) => {
    const hasError =
        config &&
        (config.error ||
            (config.tempPasswordExpirationEnabled &&
                (config.tempPasswordLocked || config.tempPasswordExpired)));

    if (!hasError) {
        return undefined;
    }
    let errorTitle = '';
    let errorMessage = [];
    let renderMessageAsHTML = false;
    let shoulClearMessageOnPasswordChange = false;

    if (config.cookiesDisabled) {
        errorTitle = config.cookiesDisabledMessage;
        errorMessage = [config.cookiesDisabledInstruction];
    } else if (config.userLocked) {
        renderMessageAsHTML = true;
        errorMessage = [config.userLockedMessage];
    } else if (config.subUserUpdatePin) {
        renderMessageAsHTML = true;
        errorMessage = [config.subUserUpdatePinMessage];
    } else if (config.userHold) {
        renderMessageAsHTML = true;
        errorMessage = [config.userHoldMessage];
    } else if (config.concurrentSessionNotAllowed) {
        renderMessageAsHTML = true;
        errorMessage = [config.concurrentSessionErrorMsg];
    } else if (config.invalidLogin) {
        errorMessage = [config.invalidLoginMessage];

        if (config.firstTimeUse) {
            errorMessage.push(config.firstTimeUserMessage);
        }
    } else if (config.disclosureRejected) {
        errorMessage = [config.disclosureRejectedMessage];
    } else if (config.ibPassInvalid) {
        errorMessage = [config.ibPassInvalidMessage];
    } else if (config.invalidReferrerDomain) {
        errorMessage = [config.invalidReferrerDomainMessage];
    } else if (config.hostAccessDenied) {
        renderMessageAsHTML = true;

        if (config.hostAccessDeniedMessage && config.errorCode) {
            errorMessage = [
                config.hostAccessDeniedMessage.replace(
                    '21001',
                    config.errorCode,
                ),
            ];
        }
    } else if (config.hostSubAccessDenied) {
        errorMessage = [config.hostSubAccessDeniedMessage];
    } else if (config.whiteListedIPsCantLogin) {
        errorMessage = [config.whiteListedIPsCantLoginErrorMsg];
    } else if (config.disclosureDeclined) {
        errorMessage = [config.disclosureDeclinedMessage];
    } else if (config.userAlreadyConverted) {
        renderMessageAsHTML = true;
        errorTitle = config.userAlreadyConvertedHeader;
        errorMessage.push(config.userAlreadyConvertedMessage);

        if (config.isForgotPasswordEnabled) {
            errorMessage.push(`<a
                        id="alreadyConvertedForgotPasswordLink"
                        class="inline-block-link"
                        href=${config.context}/app/authUpdate
                    >
                        ${config.userAlreadyConvertedForgotMessage}
                    </a>`);
        }
    } else if (config.fractalBlock) {
        errorMessage = [
            `${config.fractalBlockMessage} ${config.errorCodeLabel}: ${config.errorCode}`,
        ];
    } else if (config.featureUnavailable) {
        errorMessage = [
            `${config.featureUnavailableMessage} ${config.errorCodeLabel}: ${config.errorCode}`,
        ];
    } else if (config.oauthGotoFullSite) {
        renderMessageAsHTML = true;
        errorMessage = [config.oauthGotoFullSiteMessage];
    } else if (
        config.tempPasswordExpirationEnabled &&
        config.tempPasswordExpired
    ) {
        shoulClearMessageOnPasswordChange = true;
        renderMessageAsHTML = true;

        let { tempPasswordExpiredMsg } = config;

        if (
            tempPasswordExpiredMsg &&
            tempPasswordExpiredMsg.indexOf('forgotPasswordLink') !== -1
        ) {
            const elem = document.createElement('div');
            elem.innerHTML = tempPasswordExpiredMsg;
            const forgotPasswordLink = elem.querySelector(
                'a#forgotPasswordLink',
            );

            const href =
                forgotPasswordLink && forgotPasswordLink.getAttribute('href');

            if (href === '#') {
                forgotPasswordLink.href = `${config.context}/app/authUpdate`;
                tempPasswordExpiredMsg = elem.innerHTML;
            }
        }

        errorMessage = [tempPasswordExpiredMsg];
    } else if (
        config.tempPasswordExpirationEnabled &&
        config.tempPasswordLocked
    ) {
        renderMessageAsHTML = true;
        shoulClearMessageOnPasswordChange = true;
        errorMessage = [config.tempPasswordLockedMsg];
    } else if (config.errorCode) {
        renderMessageAsHTML = true;
        errorMessage = [
            `${config.serviceUnavailableMessage} ${config.errorCodeLabel}: ${config.errorCode}`,
        ];
    } else {
        renderMessageAsHTML = true;
        errorMessage = [config.serviceUnavailableMessage];
    }

    let messageComponent;

    if (errorMessage.length) {
        messageComponent = errorMessage.map((msg) => {
            if (renderMessageAsHTML) {
                return <div dangerouslySetInnerHTML={{ __html: msg }} />;
            }

            return <div key={msg}>{msg}</div>;
        });
    }

    return {
        shoulClearMessageOnPasswordChange,
        component: (
            <Fragment>
                <div className="fluid-callout-memo__icon-container">
                    <span
                        className={cx(
                            `fluid-callout-memo__icon`,
                            'fluid-icon-exclamation-triangle',
                        )}
                    />
                </div>
                <div className="fluid-callout-memo__text-container">
                    {errorTitle && (
                        <div className="fluid-callout-memo__title-container">
                            <h2 className="heading heading--h2 fluid-callout__title">
                                {errorTitle}
                            </h2>
                        </div>
                    )}

                    <div className="fluid-callout-memo__msg-container">
                        <div className="fluid-callout-memo__msg">
                            {messageComponent && messageComponent}
                        </div>
                    </div>
                </div>
            </Fragment>
        ),
    };
};

const getMessageDependencies = (configParam) => {
    const config = configParam ?? {};

    return [
        config.error,
        config.cookiesDisabled,
        config.cookiesDisabledMessage,
        config.cookiesDisabledInstruction,
        config.userLocked,
        config.userLockedMessage,
        config.subUserUpdatePin,
        config.subUserUpdatePinMessage,
        config.userHold,
        config.userHoldMessage,
        config.concurrentSessionNotAllowed,
        config.concurrentSessionErrorMsg,
        config.invalidLogin,
        config.invalidLoginMessage,
        config.firstTimeUse,
        config.firstTimeUserMessage,
        config.disclosureRejected,
        config.disclosureRejectedMessage,
        config.ibPassInvalid,
        config.ibPassInvalidMessage,
        config.invalidReferrerDomain,
        config.invalidReferrerDomainMessage,
        config.hostAccessDenied,
        config.hostAccessDeniedMessage,
        config.errorCode,
        config.hostSubAccessDenied,
        config.hostSubAccessDeniedMessage,
        config.whiteListedIPsCantLogin,
        config.whiteListedIPsCantLoginErrorMsg,
        config.disclosureDeclined,
        config.userAlreadyConverted,
        config.userAlreadyConvertedHeader,
        config.userAlreadyConvertedMessage,
        config.isForgotPasswordEnabled,
        config.userAlreadyConvertedForgotMessage,
        config.fractalBlock,
        config.fractalBlockMessage,
        config.errorCodeLabel,
        config.featureUnavailable,
        config.featureUnavailableMessage,
        config.oauthGotoFullSite,
        config.oauthGotoFullSiteMessage,
        config.serviceUnavailableMessage,
        config.logoutTitle,
        config.logoutMessage,
        config.tempPasswordExpired,
        config.tempPasswordExpiredMsg,
        config.tempPasswordLocked,
        config.tempPasswordLockedMsg,
    ];
};

export default {};
export { errorHelper, getMessageDependencies };
